import type { IUser } from "@citrine/resources/user";
import { UserClient } from "@citrine/resources/user";

/**
 * Fetch information about the user identified by UUID
 *
 * If the second `field` parameter is provided, the response will be that field
 * from the user object. Otherwise, the entire user object will be returned.
 *
 * Example:
 *  const someUser = useUser("abc-123");
 *  const screenName = useUser("def-456", "screen_name");
 */
export function useUser(userId: string | undefined): IUser | undefined;
export function useUser<K extends keyof IUser>(
  userId: string | undefined,
  field: K,
): IUser[K] | undefined;
export function useUser<K extends keyof IUser>(
  userId: string | undefined,
  field?: K,
) {
  const userMap = UserClient.getInstance().useMap(undefined, {
    enabled: Boolean(userId),
  });
  const user = userId ? userMap.data?.[userId] : undefined;
  return field ? (user?.[field] ?? undefined) : user;
}
